module.exports = __webpack_public_path__ + "static/media/Pic6.0a4e0797.jpeg";